import React, { useEffect, useState } from 'react';
import { InfoModal } from './InfoModal';
import { SocialProofPopup } from './SocialProofPopup';
import { Star, ShieldCheck } from 'lucide-react';
const PURCHASE_URL = 'https://payments.vantapro.shop/cart/44866567045222:1';
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const handlePurchaseClick = () => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    window.location.href = PURCHASE_URL;
  };
  return <div className="min-h-screen w-full bg-brand-dark font-inter text-brand-cream flex flex-col items-center" data-id="element-42">
      {/* COUNTDOWN TIMER BAR */}
      <div className="w-full bg-brand-red text-white text-center py-1.5 px-4 sticky top-0 z-50 shadow-md" data-id="element-43">
        <p className="text-xs sm:text-sm font-bold tracking-wide" data-id="element-44">
          🔥 OFERTA POR TIEMPO LIMITADO — Termina en:{' '}
          <span className="font-mono ml-1" data-id="element-45">{formatTime(timeLeft)}</span>
        </p>
      </div>

      <main className="w-full max-w-lg mx-auto flex flex-col shadow-2xl bg-brand-dark relative overflow-hidden" data-id="element-46">
        {/* HERO SECTION */}
        <section className="relative w-full bg-gradient-to-b from-brand-dark via-brand-brown to-brand-wine flex flex-col items-center justify-center py-8 px-5 text-center" data-id="element-47">
          <div className="absolute inset-0 bg-vignette pointer-events-none" data-id="element-48"></div>

          <div className="relative z-10 w-full flex flex-col items-center" data-id="element-49">
            {/* TOP BAR */}
            <div className="flex items-center gap-2 mb-6" data-id="element-50">
              <span className="text-xl" data-id="element-51">🎸</span>
              <span className="font-playfair font-bold text-lg sm:text-xl text-brand-cream tracking-wide" data-id="element-52">
                Para Docentes de{' '}
                <span className="text-brand-gold" data-id="element-53">Guitarra</span>
              </span>
            </div>

            {/* BADGE */}
            <div className="border border-brand-gold/60 bg-brand-dark/40 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6 shadow-lg" data-id="element-54">
              <p className="text-brand-gold text-[10px] sm:text-xs font-bold tracking-wider" data-id="element-55">
                ⭐ EL MATERIAL #1 PARA TUS CLASES ⭐
              </p>
            </div>

            {/* TITULAR PRINCIPAL */}
            <h1 className="font-playfair text-brand-cream text-3xl sm:text-4xl font-bold mb-2" data-id="element-56">
              Mega Pack de Guitarra: recursos listos para usar
            </h1>

            {/* IMAGEN CENTRAL */}
            <div className="relative w-full max-w-[260px] sm:max-w-[300px] mx-auto my-4 cursor-pointer hover:scale-[1.02] transition-transform duration-300" onClick={handlePurchaseClick} data-id="element-57">
              <img src="https://cdn.magicpatterns.com/uploads/tvDDWnySSzaqJjstUCsD5W/Diseno_sin_titulo_(4).png" alt="Mega Pack Guitarra" className="w-full h-auto drop-shadow-2xl" data-id="element-58" />
            </div>

            {/* SUBTÍTULO PRINCIPAL */}
            <h2 className="font-playfair text-brand-gold text-2xl sm:text-3xl font-bold leading-tight my-5" data-id="element-59">
              Herramientas
              <br data-id="element-60" />
              Completas
            </h2>

            {/* TEXTO DESCRIPTIVO */}
            <div className="text-brand-cream text-sm sm:text-base leading-relaxed mb-4" data-id="element-61">
              <p data-id="element-62">6 Tomos + 3 Bonos en PDF</p>
              <p className="text-brand-gold font-semibold" data-id="element-63">
                Aplicable a guitarra clásica, acústica y eléctrica
              </p>
              <p data-id="element-64">material y recursos listos</p>
              <p data-id="element-65">para usar en tus clases desde hoy.</p>
            </div>

            {/* PAIN POINT - TIEMPO */}
            <div className="bg-brand-dark/50 border border-brand-gold/20 rounded-xl p-4 mb-8 w-full" data-id="element-66">
              <p className="text-brand-cream/90 text-sm italic leading-relaxed" data-id="element-67">
                "¿Cansado de pasar{' '}
                <span className="text-brand-gold font-bold" data-id="element-68">
                  horas armando clases
                </span>{' '}
                desde cero, buscando material suelto por internet y sin una
                estructura clara para tus alumnos?"
              </p>
              <p className="text-brand-gold text-xs font-bold mt-2" data-id="element-69">
                Este pack te devuelve tu tiempo.
              </p>
            </div>

            {/* BOTÓN PRINCIPAL */}
            <button onClick={handlePurchaseClick} className="w-full bg-brand-orange text-white font-bold text-lg py-4 rounded-xl shadow-[0_0_20px_rgba(232,114,12,0.4)] hover:shadow-[0_0_25px_rgba(232,114,12,0.6)] hover:scale-[1.02] transition-all duration-200 mb-4" data-id="element-70">
              Adquirir Ahora por $19.990 →
            </button>

            {/* BOTÓN SECUNDARIO */}
            <button onClick={() => setIsModalOpen(true)} className="w-full border-2 border-brand-gold/50 text-brand-gold font-bold text-base py-3.5 rounded-xl hover:bg-brand-gold/10 transition-colors duration-200" data-id="element-71">
              Más Información
            </button>
          </div>
        </section>

        {/* Divider */}
        <div className="h-1 w-full bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent" data-id="element-72"></div>

        {/* PAIN POINT SECTION */}
        <section className="w-full bg-white py-10 px-5 text-center" data-id="element-73">
          <h3 className="font-playfair text-xl sm:text-2xl font-bold text-brand-brown mb-4 leading-tight" data-id="element-74">
            Sabemos lo que vivís como docente de guitarra...
          </h3>
          <div className="space-y-3 text-brand-brown/70 text-sm leading-relaxed max-w-sm mx-auto" data-id="element-75">
            <p data-id="element-76">⏰ Horas armando planificaciones que nunca terminan.</p>
            <p data-id="element-77">📚 Material disperso, incompleto, sin hilo conductor.</p>
            <p data-id="element-78">😓 Alumnos que no avanzan porque falta estructura.</p>
            <p data-id="element-79">🔄 Repetir siempre lo mismo sin saber cómo escalar.</p>
          </div>
          <p className="text-brand-orange font-bold text-base mt-6" data-id="element-80">
            El Mega Pack resuelve todo esto de una vez.
          </p>
        </section>

        {/* Divider */}
        <div className="h-1 w-full bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent" data-id="element-81"></div>

        {/* TOMOS SECTION - WHITE */}
        <section className="w-full bg-white py-12 px-5" data-id="element-82">
          <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-brand-brown text-center mb-3" data-id="element-83">
            ¿Qué incluye el Mega Pack?
          </h3>
          <p className="text-brand-brown/60 text-sm text-center mb-8" data-id="element-84">
            Todo lo que necesitás para dejar de improvisar y empezar a enseñar
            con sistema
          </p>

          <div className="space-y-4" data-id="element-85">
            {['Diagnóstico, Niveles y Planificación', 'Mapa del diapasón para enseñar', "Improvisación Rock/Mixta — Pentatónica 'sobre los cambios'", 'Acompañamiento armónico moderno', 'Reharmonización y recursos armónicos', 'Arreglos y repertorio docente — Chord Melody + Texturas'].map((tomo, index) => <div key={index} className="bg-gray-50 border border-brand-brown/10 rounded-xl p-4 flex gap-4 items-start hover:border-brand-gold/40 transition-colors" data-id="element-86">
                <div className="bg-brand-gold/15 text-brand-gold font-bold rounded-lg w-10 h-10 flex items-center justify-center shrink-0 border border-brand-gold/30" data-id="element-87">
                  {index + 1}
                </div>
                <div data-id="element-88">
                  <h4 className="font-bold text-brand-brown mb-1" data-id="element-89">
                    Tomo {index + 1}
                  </h4>
                  <p className="text-brand-brown/70 text-sm leading-snug" data-id="element-90">
                    {tomo}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-8" data-id="element-91">
            <button onClick={handlePurchaseClick} className="w-full bg-brand-orange text-white font-bold text-lg py-4 rounded-xl shadow-[0_0_15px_rgba(232,114,12,0.3)] hover:shadow-[0_0_20px_rgba(232,114,12,0.5)] hover:scale-[1.02] transition-all duration-200" data-id="element-92">
              Sí, quiero los 6 Tomos →
            </button>
          </div>
        </section>

        {/* Divider */}
        <div className="h-1 w-full bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent" data-id="element-93"></div>

        {/* BONOS SECTION - WHITE */}
        <section className="w-full bg-white py-12 px-5 text-center" data-id="element-94">
          <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-brand-brown mb-2" data-id="element-95">
            🎁 BONOS GRATIS POR HOY
          </h3>
          <p className="text-brand-brown/70 text-sm mb-2" data-id="element-96">
            Estos 3 bonos son{' '}
            <span className="text-brand-orange font-bold" data-id="element-97">GRATIS</span> si
            adquieres hoy
          </p>
          <p className="text-brand-red font-bold text-xs mb-8 animate-pulse" data-id="element-98">
            ⏰ Solo por tiempo limitado — después tendrán costo adicional
          </p>

          <div className="space-y-5 text-left" data-id="element-99">
            {["30 Planes de Clase Listos (60')", 'Evaluaciones + Rúbricas + Seguimiento', 'Banco de Recursos Docente (Rock/Mixto)'].map((bono, index) => <div key={index} className="bg-gray-50 border-2 border-brand-gold/30 rounded-xl p-5 relative overflow-hidden" data-id="element-100">
                <div className="absolute top-0 right-0 bg-brand-red text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg" data-id="element-101">
                  GRATIS HOY
                </div>
                <h4 className="font-bold text-brand-brown mb-1" data-id="element-102">
                  Bono {index + 1}
                </h4>
                <p className="text-brand-brown/70 text-sm" data-id="element-103">{bono}</p>
              </div>)}
          </div>

          {/* Persuasive CTA after bonos */}
          <div className="mt-10" data-id="element-104">
            <p className="text-brand-brown font-bold text-base mb-3" data-id="element-105">
              6 Tomos + 3 Bonos = Todo lo que necesitás
            </p>
            <button onClick={handlePurchaseClick} className="w-full bg-brand-orange text-white font-bold text-lg py-4 rounded-xl shadow-[0_0_20px_rgba(232,114,12,0.3)] hover:shadow-[0_0_25px_rgba(232,114,12,0.5)] hover:scale-[1.02] transition-all duration-200" data-id="element-106">
              ¡Quiero el Pack Completo + Bonos Gratis! →
            </button>
          </div>
        </section>

        {/* Divider */}
        <div className="h-1 w-full bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent" data-id="element-107"></div>

        {/* TESTIMONIALS SECTION */}
        <section className="w-full bg-brand-wine py-12 px-5" data-id="element-108">
          <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-brand-gold text-center mb-10" data-id="element-109">
            Lo que dicen nuestros colegas
          </h3>

          <div className="space-y-6" data-id="element-110">
            {[{
            name: 'Alejandro M., 42 años',
            city: 'Buenos Aires',
            text: 'Llevo 15 años dando clases y este pack me organizó todo. Los planes de clase listos me ahorraron horas de preparación.'
          }, {
            name: 'María José T., 35 años',
            city: 'Córdoba',
            text: 'Mis alumnos avanzaron mucho más rápido con la estructura del Tomo 1. Excelente material para profesores.'
          }, {
            name: 'Diego F., 28 años',
            city: 'Rosario',
            text: 'El tomo de improvisación es oro puro. Mis alumnos ahora improvisan con confianza sobre los cambios.'
          }, {
            name: 'Laura P., 38 años',
            city: 'Mendoza',
            text: 'Las rúbricas de evaluación me profesionalizaron como docente. Ahora mis clases tienen estructura real.'
          }, {
            name: 'Nicolás R., 45 años',
            city: 'La Plata',
            text: 'El chord melody del Tomo 6 elevó el nivel de mis clases. Material de conservatorio adaptado para el aula.'
          }].map((testimonial, index) => <div key={index} className="bg-brand-dark/40 border border-brand-cream/15 rounded-xl p-6 shadow-lg" data-id="element-111">
                <div className="flex gap-1 mb-3" data-id="element-112">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-brand-gold text-brand-gold" data-id="element-113" />)}
                </div>
                <p className="text-brand-cream/90 text-sm italic mb-4 leading-relaxed" data-id="element-114">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-115">
                  <div className="w-10 h-10 rounded-full bg-brand-mid flex items-center justify-center text-brand-gold font-bold border border-brand-gold/30" data-id="element-116">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-117">
                    <p className="font-bold text-brand-cream text-sm" data-id="element-118">
                      {testimonial.name}
                    </p>
                    <p className="text-brand-gold text-xs" data-id="element-119">
                      {testimonial.city}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* CTA after testimonials */}
          <div className="mt-10 text-center" data-id="element-120">
            <p className="text-brand-cream/80 text-sm mb-3" data-id="element-121">
              Ellos ya transformaron sus clases. Ahora es tu turno.
            </p>
            <button onClick={handlePurchaseClick} className="w-full bg-brand-orange text-white font-bold text-lg py-4 rounded-xl shadow-[0_0_15px_rgba(232,114,12,0.3)] hover:shadow-[0_0_20px_rgba(232,114,12,0.5)] hover:scale-[1.02] transition-all duration-200" data-id="element-122">
              Quiero transformar mis clases →
            </button>
          </div>
        </section>

        {/* FINAL CTA SECTION - PRICING (WHITE) */}
        <section className="w-full bg-white py-16 px-5 text-center" data-id="element-123">
          <h3 className="font-playfair text-3xl sm:text-4xl font-bold text-brand-brown mb-3 leading-tight" data-id="element-124">
            ¡No dejes pasar esta oportunidad!
          </h3>
          <p className="text-brand-brown/60 text-sm mb-8 max-w-sm mx-auto" data-id="element-125">
            Accede ahora a las 6 herramientas + 3 bonos gratis y dejá de perder
            tiempo armando clases desde cero
          </p>

          {/* PRICING */}
          <div className="mb-6" data-id="element-126">
            <p className="text-gray-400 text-xl line-through mb-1" data-id="element-127">$49.990</p>
            <div className="flex items-center justify-center gap-3" data-id="element-128">
              <p className="text-brand-orange font-playfair text-5xl sm:text-6xl font-bold" data-id="element-129">
                $19.990
              </p>
            </div>
          </div>

          {/* URGENCY BADGE */}
          <div className="inline-block bg-brand-red text-white font-bold text-sm px-6 py-2 rounded-full mb-8 animate-pulse shadow-lg" data-id="element-130">
            🔥 SOLO POR HOY A ESTE PRECIO 🔥
          </div>

          <button onClick={handlePurchaseClick} className="w-full bg-brand-orange text-white font-bold text-xl py-6 rounded-2xl shadow-[0_4px_25px_rgba(232,114,12,0.5)] hover:shadow-[0_4px_40px_rgba(232,114,12,0.7)] hover:scale-[1.03] transition-all duration-300 mb-4 relative overflow-hidden" data-id="element-131">
            <span className="relative z-10" data-id="element-132">Adquirir Ahora por $19.990 →</span>
          </button>

          <div className="flex items-center justify-center gap-4 mt-4 text-gray-400 text-xs" data-id="element-133">
            <span className="flex items-center gap-1" data-id="element-134">
              <ShieldCheck size={14} data-id="element-135" /> Pago seguro
            </span>
            <span data-id="element-136">•</span>
            <span data-id="element-137">Acceso inmediato</span>
            <span data-id="element-138">•</span>
            <span data-id="element-139">Garantía 7 días</span>
          </div>
        </section>

        {/* GARANTÍA SECTION (BLACK) */}
        <section className="w-full bg-black py-12 px-5 text-center" data-id="element-140">
          <div className="max-w-sm mx-auto" data-id="element-141">
            <div className="w-20 h-20 mx-auto mb-5 rounded-full bg-brand-gold/10 border-2 border-brand-gold/50 flex items-center justify-center" data-id="element-142">
              <ShieldCheck size={40} className="text-brand-gold" data-id="element-143" />
            </div>
            <h4 className="font-playfair text-xl sm:text-2xl font-bold text-brand-gold mb-3" data-id="element-144">
              Garantía de Satisfacción
            </h4>
            <p className="text-white/80 text-sm leading-relaxed mb-4" data-id="element-145">
              Si dentro de los primeros{' '}
              <span className="text-brand-gold font-bold" data-id="element-146">7 días</span> sentís
              que el Mega Pack no es para vos, te devolvemos el 100% de tu
              dinero. Sin preguntas, sin vueltas.
            </p>
            <p className="text-white/40 text-xs" data-id="element-147">
              Tu compra está protegida. Cero riesgo para vos.
            </p>
          </div>
        </section>
      </main>

      <InfoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onPurchase={handlePurchaseClick} data-id="element-148" />

      <SocialProofPopup data-id="element-149" />
    </div>;
}